import { HttpService } from '../services/http';
import { Utils } from '../utils';

/**
 * JS component for actions on the page for each individual Lab
 */
function TestCenterComponent() {
  const httpService = new HttpService();
  const utils = new Utils();
  const nearLabsContainer = document.querySelector('#test-center-container');
  const labPostalCode = document.querySelector('#labDetail').dataset.zip;

  /**
   * Get Labs near current Lab
   */
  function getLabsNearLab() {
    httpService
      .get(`${process.env.API_URL}/api/v1/labs/nearPostalCode?postalCode=${labPostalCode}&labCount=20`)
      .then((response) => {
        let labItems = '';
        response.labs.forEach((lab) => (labItems += renderNearLabsItem(lab)));
        nearLabsContainer.innerHTML = labItems;
        utils.showHoursListener('.lab-item-show-hide', 'table.labHoursPsc');
      });
  }

  /**
   * RENDER psc html element
   *
   * @param psc        Object with the data from a lab
   * @returns {string} String HTML element with lab information
   */
  function renderNearLabsItem(psc) {
    const labTitle = psc.url?.url
      ? `<a href='/std-testing-${psc.url.url}/'>${psc.address} ${psc.address2 ? psc.address2 : ''}</a>`
      : `<span>${psc.address} ${psc.address2 ? psc.address2 : ''}</span>`;

    let pscItem = `
      <div class="column">
        <strong>
          ${labTitle}
        </strong>
        <br />
        ${psc.city} ${psc.state} ${psc.zip_code}
        <br />
        <strong>Distance:</strong> ${parseFloat(psc.distance).toFixed(2)} mile(s)
        <br />
        <span class="block">
          <strong>Hours:</strong>
          <span class="hours-show-hide lab-item-show-hide">
            <span>Show Hours ▼</span>
            <span>Hide Hours ▲</span>
          </span>
        </span>
        <br />
        <table class="labHours labHoursPsc labHours-small">
          <tbody>`;

    psc.opening_hours.forEach((day) => {
      const lunch = psc.lunch.find((lunch) => lunch.day === day.day);
      pscItem += `
            <tr>
              <th>
                <div class="${lunch ? '' : 'lab-hours-no-lunch'}">
                  ${day.day}
                </div>
                ${lunch ? '<div>Closed for lunch</div>' : ''}
              </th>
              <td>
                <div class="${lunch ? '' : 'lab-hours-no-lunch'}">
                  ${utils.formatAMPM(new Date(day.start.date))} - ${utils.formatAMPM(new Date(day.end.date))}
                </div>
                ${
                  lunch
                    ? '<div>' +
                      utils.formatAMPM(new Date(lunch.start.date)) +
                      ' - ' +
                      utils.formatAMPM(new Date(lunch.end.date)) +
                      '</div>'
                    : ''
                }
              </td>
            </tr>
          `;
    });
    pscItem += `</tbody></table><br /></div>`;

    return pscItem;
  }

  getLabsNearLab();
}

window.testCenter = new TestCenterComponent();
